/**
 * 展示格式化工具。所有数值←→文案的转换集中在这里，避免各页面各写一套。
 *
 * ══ 一条硬口径（与 apps/admin、apps/provider 的 format.ts 同一套）══
 * **接口没给的字段一律显示「未提供」，绝不用 0 或空白冒充。**
 * 把「未授权」写成「0 项」、把「没有记录」写成「0 次」，都是在替后端说一句它没说的话。
 */

/** 缺失值（字段未下发 / 为空 / 为 null）的统一文案。 */
export const MISSING_TEXT = '未提供';

export function formatDate(iso: string | null | undefined): string {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return String(iso);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

export function formatDateTime(iso: string | null | undefined): string {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return String(iso);
  return `${formatDate(iso)} ${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`;
}

/** 时间戳：接口没下发就写「未提供」，不显示空串、也不拿别的时间顶替。 */
export function formatDateTimeOrMissing(iso: string | null | undefined): string {
  return iso ? formatDateTime(iso) : MISSING_TEXT;
}

export function formatSlot(iso: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  const week = ['日', '一', '二', '三', '四', '五', '六'][d.getDay()];
  return `${d.getMonth() + 1} 月 ${d.getDate()} 日 周${week} ${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`;
}

/** 金额：数据库存的是元为单位的 number，此处按万 / 亿折算展示。 */
export function formatMoney(value: number): string {
  if (Math.abs(value) >= 100_000_000) return `¥${(value / 100_000_000).toFixed(1)} 亿`;
  if (Math.abs(value) >= 10_000) return `¥${(value / 10_000).toFixed(0)} 万`;
  return `¥${value.toLocaleString('zh-CN')}`;
}

export function formatPct(value: number, digits = 1): string {
  return `${value.toFixed(digits)}%`;
}

/** 带符号数值，用于归因条与环比 */
export function signed(value: number, digits = 1): string {
  const v = Number(value.toFixed(digits));
  return `${v > 0 ? '+' : ''}${v}`;
}

export function levelColorKey(level: string): 'info' | 'warn' | 'danger' {
  if (level === 'danger') return 'danger';
  if (level === 'warn') return 'warn';
  return 'info';
}
